import {
  DependencyList,
  RefObject,
  useCallback,
  useEffect,
  useRef,
} from "react";

export const useAutoFocus = <T = HTMLInputElement>(
  deps: DependencyList = [],
  delay: number = 100,
): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const element = ref.current as HTMLElement;
      element?.focus?.();
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [...deps, delay]);

  return ref;
};

export const useControlledFocus = <T = HTMLInputElement>(): readonly [
  RefObject<T>,
  () => void,
] => {
  const ref = useRef<T>(null);

  const applyFocus = useCallback(() => {
    const element = ref.current as HTMLElement;
    element?.focus?.();
  }, []);

  return [ref, applyFocus];
};
